"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ButtonDiffuseCell;
var _react = _interopRequireWildcard(require("react"));
var _Video = _interopRequireDefault(require("./Video"));
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ButtonDiffuseCell(_ref) {
  var cell = _ref.cell,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    play = _ref3[0],
    setPlay = _ref3[1];
  var startVideo = function startVideo() {
    if (play) {
      return;
    }
    logEvent('click', {
      cellId: cell.id
    });
    setPlay(true);
    console.log('treeosk-btn-' + cell.gpio_number);
    setTimeout(function () {
      setPlay(false);
    }, 10000);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      width: '100%'
    },
    onClick: startVideo
  }, play ? /*#__PURE__*/_react.default.createElement(_Video.default, _extends({
    style: {
      height: '100%',
      width: '100%',
      position: 'relative',
      objectFit: 'cover'
    },
    src: uriTransformer((0, _utils.i18nData)(cell, 'video_start_uri', intl, defaultLanguage))
  }, cell.image_start_uri ? {
    poster: uriTransformer((0, _utils.i18nData)(cell, 'image_start_uri', intl, defaultLanguage))
  } : {})) : /*#__PURE__*/_react.default.createElement(_Video.default, _extends({
    style: {
      height: '100%',
      width: '100%',
      position: 'relative',
      objectFit: 'cover'
    },
    src: uriTransformer((0, _utils.i18nData)(cell, 'video_waiting_uri', intl, defaultLanguage))
  }, cell.image_waiting_uri ? {
    poster: uriTransformer((0, _utils.i18nData)(cell, 'image_waiting_uri', intl, defaultLanguage))
  } : {})));
}